import React from 'react';
import { Control, Controller } from 'react-hook-form';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Box,
  Typography,
  useTheme,
} from '@mui/material';
import { User, Mail, Phone } from 'lucide-react';
import { CreateBookingDTO } from '../../../../types/booking';
import { Customer } from '../../../../types/customer';
import SectionTitle from './SectionTitle';

interface CustomerSectionProps {
  control: Control<CreateBookingDTO>;
  customers: Customer[];
  disabled?: boolean;
}

const CustomerSection: React.FC<CustomerSectionProps> = ({
  control,
  customers,
  disabled = false,
}) => {
  const theme = useTheme();

  return (
    <div>
      <SectionTitle icon={User} title="Select Customer" />
      <Controller
        name="customerId"
        control={control}
        rules={{ required: 'Customer is required' }}
        render={({ field, fieldState: { error } }) => (
          <FormControl fullWidth error={!!error}>
            <InputLabel>Select Customer</InputLabel>
            <Select
              {...field}
              label="Select Customer"
              disabled={disabled}
              value={field.value || ''}
            >
              {customers.map(customer => (
                <MenuItem key={customer.id} value={customer.id}>
                  <Box sx={{ py: 1 }}>
                    <Typography variant="body1">
                      {customer.firstName} {customer.lastName}
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        gap: 2,
                        mt: 0.5,
                        color: theme.palette.text.secondary,
                        fontSize: '0.875rem',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Mail size={14} />
                        <span>{customer.email}</span>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Phone size={14} />
                        <span>{customer.phone}</span>
                      </Box>
                    </Box>
                  </Box>
                </MenuItem>
              ))}
            </Select>
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        )}
      />
    </div>
  );
};

export default CustomerSection;
